module.exports = {
  monarchBaseUrl: 'https://api.jupiter.staging.qubewire.com',
  qubeAccountUrl: 'https://account.staging.qube.in',
  imagesUri: '../../../static_assets',
  bucket: 'qw-partners-ui-jupiter-staging',
  qwPartnersBaseUrl: 'https://services.jupiter.staging.qubewire.com/partners/api',
  qsGatewayBaseUrl : 'wss://gateway.store.jupiter.staging.qubewire.com/',
  duplicationStatusInterval: 5000,
  qwReportsUrl : 'https://services.jupiter.staging.qubewire.com/reports/api',
  theatreBaseUrl:'https://theatres.jupiter.staging.qubewire.com',
}
